"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getUpdatedChats_1 = __importStar(require("../actions/chats/getUpdatedChats"));
const ExponentialBackoffRecurringTaskRunner_1 = __importStar(require("./ExponentialBackoffRecurringTaskRunner"));
const constants_1 = require("../constants");
const store_1 = __importDefault(require("../store"));
class ChatsUpdater {
    constructor() {
        this.startNew = (chatsSyncedUpTo) => {
            if (this.taskRunner) {
                this.taskRunner.stop();
            }
            this.taskRunner = ExponentialBackoffRecurringTaskRunner_1.default.startNew(() => this.getUpdates(chatsSyncedUpTo), constants_1.REFRESH_CHATS_MIN_INTERVAL_MS, constants_1.REFRESH_CHATS_MAX_INTERVAL_MS, 1.2, ExponentialBackoffRecurringTaskRunner_1.StartOptions.WaitBeforeFirstRun);
        };
        this.triggerUpdate = () => {
            return this.taskRunner
                ? this.taskRunner.restart(ExponentialBackoffRecurringTaskRunner_1.StartOptions.AwaitFirstRun)
                : Promise.resolve();
        };
        this.stop = () => {
            if (this.taskRunner) {
                this.taskRunner.stop();
                this.taskRunner = undefined;
            }
        };
        this.getUpdates = (chatsSyncedUpTo) => __awaiter(this, void 0, void 0, function* () {
            const result = yield store_1.default.dispatch(getUpdatedChats_1.default(chatsSyncedUpTo));
            return result.type === getUpdatedChats_1.GET_UPDATED_CHATS_SUCCEEDED && result.payload.chats.length > 0;
        });
    }
}
const chatsUpdater = new ChatsUpdater();
exports.default = chatsUpdater;
